<template>
  <div class="h-screen dark:bg-gray-900" v-if="!$store.state.authentication.authenticated">
    <router-view />
  </div>
  <div v-else class="flex h-screen bg-gray-200 dark:bg-gray-900 font-roboto">
    <Sidebar :isOpen="isOpen"  :width="'w-72'" @update:isOpen="handleMenuUpdate"/>

    <div class="flex-1 flex flex-col overflow-hidden">
      <Header :isOpen="isOpen" @toggleMenu="toggleMenu" />

      <PullToRefresh class="flex-1 bg-gray-200 dark:bg-gray-900">
        <div class="w-full mx-auto px-5 py-2">
          <router-view :key="$route.fullPath" />
        </div>
      </PullToRefresh>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import Sidebar from './Siderbar.vue'
import Header from './Header.vue'
import PullToRefresh from '../commons/PullToRefresh.vue'

export default defineComponent({
    components: {
        Sidebar,
        Header,
        PullToRefresh,
    },
    data(){
      return {
        isOpen: false
      }
    },
    methods:{
      toggleMenu() {
        this.isOpen = !this.isOpen;
      },
      handleMenuUpdate(isOpen) {
        
        this.isOpen = isOpen;
      },
    }
});
</script>
